<template>
  <div class="h-100">
    <NavBarComponent/>
  <div class="container h-75 justify-content-md-center">
    <div class="row h-100 align-items-center">
      <div class="offset-lg-1 col-md-6 col-sm-12">
        <div class="header">Message Notification</div>
        <ol>
          <li>Open dtac call app in</li>
          <li>Go to <i class="material-icons md-24">menu</i> Menu Setting and Select "Notify on Browser"</li>
          <li>Scan the code with your phone</li>
        </ol>
        <br />
        
        <div class="download-title">Download app here</div>
        <div class="btn-group clearfix w-50">
        <a href="http://callcli.dtac.co.th/redirect?s=ios"  target="_blank" >
          <img src="https://www.dtac.co.th/call/images/btn-appstore-m.png" class="img-responsive" alt="dtac call at app store">
        </a>
        <a href="http://callcli.dtac.co.th/redirect?s=android" target="_blank">
          <img src="https://www.dtac.co.th/call/images/btn-googleplay-m.png" class="img-responsive" alt="dtac call at play store">
        </a>
        </div>
        <br />
                <br />
        <br />
      </div>
      <div class="col-md-5 col-sm-12">
        <div class="barcode-border">
        <div id="placeHolder" class="barcode" v-html="qrElement" v-if="qrElement !== '' "></div>
        <div v-else class="barcode rounded">Loading...</div>
        </div>
      </div>    
    </div>
  </div>
  </div>
</template>

<script>
import QRCode from "qrcode-generator";
import NavBarComponent from '../components/NavBarComponent'

var theTimer;
export default {
  name: "Login",
    components: {NavBarComponent},
  data() {
    return {
      webId: "",
      qrElement: "",
      monitorSetTimeout: null
    };
  },
  computed: {},
  methods: {
    async monitorToken() {
      const token = await this.$client.getToken(this.webId);
      this.$util.log("token", token);
      if (token !== "" ) {
        clearTimeout(theTimer);
        this.$util.saveToken(this.webId,token);
        this.$router.push({name:'home'});
        return;
      } else {
        theTimer = setTimeout(() => {
          this.monitorToken();
        }, 1000);
      }
    }
  },
  async mounted() {
    if (this.$route.query.a === undefined) {
      this.$router.push({ name: "notfound" });
      return;
    }
    if ( this.$util.getToken() !== '') {
      this.$router.push({name:'home'})
      return;
    }
    const response = await this.$client.requestId();
    this.$util.log("webId", response);
    this.webId = response;
    this.monitorToken();

    const typeNumber = 0;
    const errorCorrectionLevel = "H";
    let qr = QRCode(typeNumber, errorCorrectionLevel);
    qr.addData(response);
    qr.make();
    this.qrElement = qr.createImgTag(6, 10);
  }
};
</script>

<style scoped>
.barcode{
  border-radius: 10px;
  width:270px;
  height:270px;
  background-color: white;
  text-align: center;
  vertical-align: middle;
  line-height: 270px;
  display: inline-block;
}
.barcode-border{
  margin: 0 auto;
  border-radius: 20px;
  width:340px;
  height:330px;
  line-height: 330px;
  text-align: center;
  vertical-align: middle;
  background-color: #ea5084;
  box-shadow:0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(234, 80, 132, 0.46)
}
.header{
  font-size: 3rem;
  line-height: 2em;
  white-space: nowrap;
}
li {
  line-height: 2em;
}
.material-icons.md-24 {
   font-size: 24px;
   display: inline-flex;
   vertical-align: middle;
   padding-bottom:6px;
  }
.download-title {
  font-size: 1.5rem;
  line-height: 1.5em;

}
.img-responsive {
    display: block;
    max-width: 100%;
    height: auto;
}
.clearfix {
    clear: both;
}
</style>
